"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class OrganizationService {
    /**
     * @returns GetOrganizationsResponse Success
     * @throws ApiError
     */
    static getOrganizations() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/v2/organizations',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
exports.OrganizationService = OrganizationService;
